import { create } from "zustand";
import { MouseEvent as ReactMouseEvent } from "react";
import agent from "../services/api";
import { RuleBasedThread, ThreadListStats, InboxControlsState, ThreadManualAgentData } from "../types/ruleBasedInbox";
import { chatLevelMenu, chatbotMessageFeedback, chatLogsIntialData, CommonResponseModel, currentActiveChatbotThreadTypeNew, currentActiveThreadChatbotThreadData, feedbackLevel, feedbackProvidedType, getRuleBasedInboxThreadsPayload, integratedChannel, manualAgentData, metIntegrationInstagramDataNew, metaIntegrationFaceBookDataNew, metaIntegrationPhoneNumberDataNew, metaIntegrationWhatsAppDataNew, newThreadInfo, sourceDetails, threadTagsData, threadTickets, UserMeResponseDataModel, CannedResponseTemplate, selectedMessageChatbotData } from "../models/axiosModel";
import { AGENT_ACTIVITY_ACTION_TYPE, chatLogsDefaultValue, DEFAULT_PAGE_LIMIT, DEFAULT_START_FROM, DEFAULT_INBOX_CONTROLS_STATE, MANUAL_OVERRIDE_BTN_TEXT, THREAD_CHANNEL_NAMES } from "../pages/ruleBasedInbox/constants";
import { doesThreadMatchSearchFilter, getThreadVisibilityDecision, hasAssignedAgent, isChannelNameChronoxAiWebAppOrWebsite, isLastMarketingTemplateOlderThan24Hours, isUserChatExpired, isUserMessage, isWithinRecentThreshold, sortThreads } from "../pages/ruleBasedInbox/utils";
import { getValueOrDefault, hasViewDetailedLogBtnAccess } from "../utils/constants";
import { placeThreadAtBottomOfRecentGroup } from "../pages/ruleBasedInbox/utils";

/**
 * Cached entry for a loaded thread's conversation data.
 * Stored in memory for the duration of the session so navigating back
 * to a previously-opened thread does not trigger a new API call.
 */
export interface ThreadCacheEntry {
    /** Full currentActiveChatbotThreadTypeNew object with all messages */
    data: any;
    /** How many messages have been loaded so far (for pagination) */
    offset: number;
    /** Whether the server has more messages beyond what is cached */
    flagHasMoreMessages: boolean;
    /** Unix timestamp (ms) when this entry was last written */
    cachedAt: number;
}

interface wabaDetailsInterface {
    waba_name: string;
    phone_number: string;
    phone_number_id: string;
}

interface instagramAccountDetailsInterface {
    instagram_account_name: string;
    instagram_account_id: string;
}

interface RuleBasedInboxStoreInterface {

    // Thread List State
    subType: string,
    setSubType: (value: string) => void, 

    chatClicked: boolean,
    setChatClicked: (value: boolean) => void, 

    flagFilterFeedback: boolean,
    setFilterFeedback: (value: boolean) => void,

    // Thread View State
    currentActiveChatbotThread: currentActiveChatbotThreadTypeNew | null,
    setCurrentActiveChatbotThread: (value: currentActiveChatbotThreadTypeNew | null) => void,

    handleOpenMenu: (event: ReactMouseEvent<HTMLButtonElement, MouseEvent>, chatbot_thread_id: string) => void,
    handleCloseMenu: (chatbot_thread_id: string) => void,

    filteredData: chatLogsIntialData,
    setFilteredData: (value: chatLogsIntialData) => void, 

    chatLevelMenu: chatLevelMenu,
    setChatlevelMenu: (value: chatLevelMenu) => void,
    onCloseOfChatLevelMenu: () => void, 

    flagDebug: boolean,
    setFlagDebug: (value: boolean) => void,

    flagAssignAgentPopup: boolean,
    setFlagAssignAgentPopup: (value: boolean) => void,

    flagRemoveAgentPopup: boolean,
    setFlagRemoveAgentPopup: (value: boolean) => void, 

    flagNewThreadPopup: boolean, 
    setFlagNewThreadPopup: (value: boolean) => void,

    offset: number,
    setOffset: (value: number) => void,

    flagHasMoreMessagesToLoad: boolean,
    setFlagHasMoreMessagesToLoad: (value: boolean) => void,

    flagLoadingPreviousMessages: boolean,
    setFlagLoadingPreviousMessages: (value: boolean) => void,

    listOfIntegration: (metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew)[] | null,
    setListOfIntegration: (value: (metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew)[] | null) => void,

    flagAttachmentIconAnimation: boolean,
    setFlagAttachmentIconAnimation: (value: boolean) => void,

    attachmentAnimationTimeout: NodeJS.Timeout | null,
    setAttachmentAnimationTimeout: (value: NodeJS.Timeout | null) => void,

    triggerAttchmentIconHeartbeat: () => void,

    clearAttachmentAnimationTimeout: () => void,

    checkIfChatIsExpiredForLeaveBtn: (btnText: string, flagCheckForLastUserMessage: boolean) => boolean,

    handleAnimationOnClickOfManualOverrideBtn: (getManualOverrideConfig: (currentActiveChatbotThread: currentActiveChatbotThreadTypeNew | null) => string) => void,

    flagNeedToShowDetailedLogBtn: boolean,
    setFlagNeedToShowDetailedLogBtn: (value: boolean) => void,

    flagViewDetailedLog: boolean,
    setFlagViewDetailedLog: (value: boolean) => void,

    needToShowViewDetailedLogBtn: (userDetail: UserMeResponseDataModel) => boolean, 

    cannedResponseList: CannedResponseTemplate[] | null,
    setCannedResponseList: (value: CannedResponseTemplate[] | null) => void,

    currentCannedRes: CannedResponseTemplate | null,
    setCurrentCannedRes: (value: CannedResponseTemplate | null) => void,

    flagPreviewAndSendCannedResPopup: boolean,
    setFlagPreviewAndSendCannedResPopup: (value: boolean) => void,

    onChangeOfCannedResMsg: (value: string, index: number) => void,

    getCannedResponseDataApi: (canned_response_template_id: string | null) => Promise<any>,

    checkAgentActivityMsgEnabled: (integrationListNewStructure: (metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew)[] | null) => boolean,

    flagSendAgentActivityMsgConfirmation: boolean,
    setFlagSendAgentActivityMsgConfirmation: (value: boolean) => void,

    selectedMessageChatbotData: selectedMessageChatbotData | null,
    setSelectedMessageChatbotData: (value: selectedMessageChatbotData | null) => void,

    // Thread Info State
    flagOpenThreadInfoBlock: boolean,
    setFlagOpenThreadInfoBlock: (value: boolean) => void,

    flagAssignThreadTagPopup: boolean,
    setFlagAssignThreadTagPopup: (value: boolean) => void,

    threadTagsData: threadTagsData[] | null,
    setThreadTagsData: (value: threadTagsData[] | null) => void,
    getThreadTagApi: () => Promise<CommonResponseModel<threadTagsData>>,

    selectedThreadTag: threadTagsData | null,
    setSelectedThreadTag: (value: threadTagsData | null) => void,

    flagUpdateThreadTagPopup: boolean,
    setFlagUpdateThreadTagPopup: (value: boolean) => void,

    flagDeleteThreadTagConfirmation: boolean,
    setFlagDeleteThreadTagConfirmation: (value: boolean) => void,

    threadInfoTabValue: number,
    setThreadInfoTabValue:  (value: number) => void,

    // True while the chat is being fetched for the Info tab / Agent Data tab skeleton loaders.
    // Mirrors isLoadingChat (local state in RuleBasedInbox) except inside handleToggleManualOverride,
    // since the thread info panel shouldn't skeleton-reload on assign/join/leave actions.
    isInfoTabLoading: boolean,
    setIsInfoTabLoading: (value: boolean) => void,

    sourceDetails: sourceDetails | {},
    setSourceDetails: (value: sourceDetails | {}) => void,

    feedbackDetails: chatbotMessageFeedback[],
    setFeedbackDetails: (value: chatbotMessageFeedback[]) => void, 

    feedbackProvidedTypeData: feedbackProvidedType[],
    setFeedbackProvidedTypeData: (value: feedbackProvidedType[]) => void,

    feedbackLevelData: feedbackLevel[],
    setFeedbackLevelData: (value: feedbackLevel[]) => void,

    isFeedbackFormOpen: boolean,
    setIsFeedbackFormOpen: (value: boolean) => void,

    chatInfoClicked: boolean,
    setChatInfoClicked: (value: boolean) => void,
    toggleThreadInfoPanel: () => void,

    // Thread list state
    threads: RuleBasedThread[];
    setThreads: (threads: RuleBasedThread[]) => void;

    // Stats state
    stats: ThreadListStats;
    setStats: (stats: ThreadListStats) => void;

    // Loading state
    isLoading: boolean;
    setIsLoading: (isLoading: boolean) => void;

    // Selected thread
    selectedThreadId: string | null;
    setSelectedThreadId: (threadId: string | null) => void;

    selectedThread: RuleBasedThread | null;
    setSelectedThread: (thread: RuleBasedThread | null) => void;

    // Current user assignment ID (for "Assigned to Me" filter)
    userAssignmentId: number | null;
    setUserAssignmentId: (id: number | null) => void;

    // Filters state
    filters: InboxControlsState;
    setFilters: (filters: InboxControlsState) => void;

    // Build payload from filters and pagination
    buildPayload: (startFrom: number, limit: number) => getRuleBasedInboxThreadsPayload;

    // Fetch threads from API
    fetchThreads: (startFrom?: number, limit?: number) => Promise<void>;

    // Thread detail state
    threadDetail: any | null; // Will be typed properly
    setThreadDetail: (detail: any | null) => void;
    isLoadingThreadDetail: boolean;
    setIsLoadingThreadDetail: (loading: boolean) => void;

    // Fetch thread details from API
    fetchThreadDetail: (threadId: string, offset?: number, limit?: number) => Promise<void>;

    // ============ Thread Unread Tracking (Frontend-only) ============
    // Tracks which threads have unread messages (new messages via socket while not open)
    unreadThreads: Record<string, boolean>;
    markThreadAsUnread: (threadId: string) => void;
    clearThreadUnread: (threadId: string) => void;
    isThreadUnread: (threadId: string) => boolean;

    // ============ Socket Handling Functions ============

    // Update thread in list (for new messages - highlight and update last_message_time)
    // placeAtBottomOfRecent: socket-only — insert after the last "Recent" thread instead of sorting to absolute top
    updateThreadInList: (threadId: string, lastMessageTime: string, lastActivityInboxCriteriaTimeStamp: string, flagHighlight?: boolean, flagNewMessages?: boolean, lastMessage?: any, manual_agent_data?: ThreadManualAgentData[], placeAtBottomOfRecent?: boolean) => void;

    // Add new thread to list (for new user conversations)
    addNewThreadToList: (thread: RuleBasedThread) => void;

    // Update thread metadata (for static_workflow_inbox_activity)
    updateThreadMetadata: (threadId: string, updates: {
        thread_status?: any;
        thread_tags?: any[];
        thread_notes?: any[];
        thread_ticket_data?: threadTickets[];
        flag_archive?: boolean;
    }) => void;

    // Remove highlight from thread after timeout
    removeThreadHighlight: (threadId: string) => void;

    // ============ Recent Chats Tracking ============
    // Tracks which threads are marked as "Recent" (within 15 min threshold)
    // On socket updates, recent threads are moved to the bottom of the Recent group
    // (not re-sorted to absolute top by timestamp). Page load still sorts by timestamp.
    // Key: threadId, Value: true if thread is marked as recent
    recentThreadIds: Record<string, boolean>;

    // Mark a thread as recent (called when adding new thread or receiving message on page 1)
    markThreadAsRecent: (threadId: string) => void;

    // Remove thread from recent list (called when thread is older than threshold)
    unmarkThreadAsRecent: (threadId: string) => void;

    // Check if a thread is marked as recent
    isThreadRecent: (threadId: string) => boolean;

    // Check all threads and update their recent status based on current timestamp
    // Returns array of thread IDs that were removed from recent
    refreshRecentThreads: () => string[];

    // Clear all recent thread IDs (called when navigating away from page 1)
    clearAllRecentThreads: () => void;

    initializeRecentThreads: () => void;

    // Initialize recent threads based on current thread list timestamps
    userInfoSearchPhrase: string, 
    setUserInfoSearchPhrase: (value: string) => void, 

    ticketInfoSearchPhrase: string,
    setTicketInfoSearchPhrase: (value: string) => void

    // ============ Thread Conversation Cache ============
    // Stores loaded thread conversation data keyed by thread_id.
    // Avoids redundant API calls when navigating between threads.
    threadCache: Record<string, ThreadCacheEntry>;

    /** Write or overwrite a cache entry for a thread */
    setThreadCache: (threadId: string, entry: ThreadCacheEntry) => void;

    /** Returns the cached entry or null if not present */
    getThreadFromCache: (threadId: string) => ThreadCacheEntry | null;

    /** Remove a single thread from the cache (use before force-refresh) */
    clearThreadFromCache: (threadId: string) => void;

    /** Wipe the entire cache (e.g. on page unmount or filter change) */
    clearAllThreadCache: () => void;

    // ============ Thread Scroll Position Memory ============
    // Persists the user's scroll offset per thread for the session so that
    // navigating back to a cached thread restores the exact scroll position
    // instead of jumping to the bottom.

    /** Map of threadId → last-known scrollTop (px) */
    threadScrollPositions: Record<string, number>;

    /** Persist the user's current scroll offset for a thread */
    saveThreadScrollPosition: (threadId: string, scrollTop: number) => void;

    /** Return the saved scrollTop for a thread, or null if never saved */
    getThreadScrollPosition: (threadId: string) => number | null;

    /** Evict the saved scroll position (e.g. after a force-refresh) */
    clearThreadScrollPosition: (threadId: string) => void;

    // ============ Per-thread composer drafts ============
    // Persists unsent chat-input text keyed by chatbot_user_id for the session,
    // so switching between cached threads restores each thread's draft and
    // prevents draft bleed across threads.

    /** Map of threadId → unsent composer draft text */
    threadDraftById: Record<string, string>;

    /** Save (or clear when empty) the composer draft for a thread */
    setThreadDraft: (threadId: string, draft: string) => void;

    /** Remove a single thread's composer draft */
    clearThreadDraft: (threadId: string) => void;

    /** Wipe all composer drafts */
    clearAllThreadDrafts: () => void;

    // To store selected agent's user_assignment_id
    selectedAgentId: string | null,
    setSelectedAgentId: (value: string | null) => void,  

    newThreadInfo: newThreadInfo | null,
    setNewThreadInfo: (value: newThreadInfo | null) => void,

    flagRenderNewConversation: boolean,
    setFlagRenderNewConversation: (value: boolean) => void,

    // Get All Integrated Channels
    getAllIntegratedChannelsApi: () => Promise<CommonResponseModel<integratedChannel>>,

    integratedChannels: integratedChannel[] | null,
    setIntegratedChannels: (value: integratedChannel[] | null) => void,

    hasThreadLastActivityInboxCriteriaChanged: (threadId: string, newLastActivityInboxCriteria: string) => boolean,

    userTimeZoneHour: string | null,
    setUserTimeZoneHour: (value: string | null) => void,

    getWabaNameAndPhoneNumberBytIntegratedChannelId: (
        integrated_channel_name: string,
        integrated_channel_id: number,
        meta_integration_whatsapp_id?: string | number,
    ) => wabaDetailsInterface | null,

    getIntegratedChannelData: (integrated_channel_name: string, integrated_channel_id: number, listOfIntegration: (metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew)[] | null, chatbotName: string) => string | undefined,

    setManualAgentDataInThreadList: (action: string, chatbot_user_id: string, agent_data: manualAgentData) => void,

    setManualAgentDataInCurrentThread: (action: string, agent_data: manualAgentData, threadId: string) => void,

    getInstaAccountNameAndIdByIntegratedChannelId: (
        integrated_channel_name: string,
        integrated_channel_id: number,
    ) => instagramAccountDetailsInterface | null,
}

export const useRuleBasedInboxStore = create<RuleBasedInboxStoreInterface>((set, get) => ({

    // Thread List State
    subType: new URLSearchParams(window.location.search).get("page_no") ? "Closed" : "Active",
    setSubType: (value: string) => set({ subType: value }), 

    chatClicked: false,
    setChatClicked: (value: boolean) => set({ chatClicked: value }),

    flagFilterFeedback: false,
    setFilterFeedback: (value: boolean) => set({ flagFilterFeedback: value }),

    // Thread View State
    currentActiveChatbotThread: null,
    setCurrentActiveChatbotThread: (value: currentActiveChatbotThreadTypeNew | null) => set({ currentActiveChatbotThread: value }),

    handleOpenMenu: (event: ReactMouseEvent<HTMLButtonElement, MouseEvent>, chatbot_thread_id: string) => {
        const { currentActiveChatbotThread, setCurrentActiveChatbotThread } = get();
        if (currentActiveChatbotThread) {
            let temp = currentActiveChatbotThread.chatbot_thread_data.map(
                (thread: currentActiveThreadChatbotThreadData) =>
                    thread.chatbot_thread_id === chatbot_thread_id
                        ? {
                            ...thread,
                            flagOpenMenu: !thread.flagOpenMenu,
                            anchorEl: event.currentTarget.parentElement,
                        }
                        : thread
            );
            setCurrentActiveChatbotThread({ ...currentActiveChatbotThread, chatbot_thread_data: temp });
        }
    },

    handleCloseMenu: (chatbot_thread_id: string) => {
        const { currentActiveChatbotThread, setCurrentActiveChatbotThread } = get();
        if (currentActiveChatbotThread) {
            let temp = currentActiveChatbotThread.chatbot_thread_data.map(
                (thread: currentActiveThreadChatbotThreadData) =>
                    thread.chatbot_thread_id === chatbot_thread_id
                        ? {
                            ...thread,
                            flagOpenMenu: false,
                            anchorEl: null,
                        }
                        : thread
            );
            setCurrentActiveChatbotThread({ ...currentActiveChatbotThread, chatbot_thread_data: temp });
        }
    },

    filteredData: chatLogsDefaultValue,
    setFilteredData: (value: chatLogsIntialData) => set({ filteredData: value }), 

    chatLevelMenu: {
        flagOpen: false,
        anchorEl: null
    },
    setChatlevelMenu: (value: chatLevelMenu) => set({ chatLevelMenu: value }),
    onCloseOfChatLevelMenu: () => {
        const { chatLevelMenu, setChatlevelMenu } = get();
        setChatlevelMenu({ ...chatLevelMenu, flagOpen: false, anchorEl: null });
    }, 

    flagDebug: false,
    setFlagDebug: (value: boolean) => set({ flagDebug: value }),

    flagAssignAgentPopup: false,
    setFlagAssignAgentPopup: (value: boolean) => set({ flagAssignAgentPopup: value }),

    flagRemoveAgentPopup: false,
    setFlagRemoveAgentPopup: (value: boolean) => set({ flagRemoveAgentPopup: value }),

    flagNewThreadPopup: false,
    setFlagNewThreadPopup: (value: boolean) => set({ flagNewThreadPopup: value }),

    offset: 0,
    setOffset: (value: number) => set({ offset: value }),

    flagHasMoreMessagesToLoad: true,
    setFlagHasMoreMessagesToLoad: (value: boolean) => set({ flagHasMoreMessagesToLoad: value }),

    flagLoadingPreviousMessages: false,
    setFlagLoadingPreviousMessages: (value: boolean) => set({ flagLoadingPreviousMessages: value }),

    listOfIntegration: null,
    setListOfIntegration: (value: (metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew)[] | null) => set({ listOfIntegration: value }),

    flagAttachmentIconAnimation: false,
    setFlagAttachmentIconAnimation: (value: boolean) => set({ flagAttachmentIconAnimation: value }),

    attachmentAnimationTimeout: null,
    setAttachmentAnimationTimeout: (value: NodeJS.Timeout | null) => set({ attachmentAnimationTimeout: value }),

    triggerAttchmentIconHeartbeat: () => {
        const { setFlagAttachmentIconAnimation, setAttachmentAnimationTimeout } = get();

        const timeout = setTimeout(() => {
            setFlagAttachmentIconAnimation(true);

            // Then stop animation after 7 seconds
            setTimeout(() => {
                setFlagAttachmentIconAnimation(false);
            }, 7000);
        }, 5000);
        setAttachmentAnimationTimeout(timeout);
    },

    clearAttachmentAnimationTimeout: () => {
        const { setAttachmentAnimationTimeout, attachmentAnimationTimeout,
            flagAttachmentIconAnimation, setFlagAttachmentIconAnimation
        } = get();

        if(attachmentAnimationTimeout){
            clearTimeout(attachmentAnimationTimeout);
            setAttachmentAnimationTimeout(null);
        }

        if(flagAttachmentIconAnimation) {
            setFlagAttachmentIconAnimation(false);
        }
    },

    checkIfChatIsExpiredForLeaveBtn: (btnText: string, flagCheckForLastUserMessage: boolean) => {
        const { currentActiveChatbotThread } = get();

        if (isChannelNameChronoxAiWebAppOrWebsite(currentActiveChatbotThread)) return false;

        if (btnText.toLowerCase() == MANUAL_OVERRIDE_BTN_TEXT['TAKEOVER']?.toLowerCase()) {
            if (currentActiveChatbotThread && !hasAssignedAgent(currentActiveChatbotThread)) {  // Only For Static Workflow
                return flagCheckForLastUserMessage ? isUserChatExpired(currentActiveChatbotThread) : isUserChatExpired(currentActiveChatbotThread) && isLastMarketingTemplateOlderThan24Hours(currentActiveChatbotThread);
            }
        } else if (btnText.toLowerCase() == MANUAL_OVERRIDE_BTN_TEXT['LEAVE']?.toLowerCase()) {
            if (currentActiveChatbotThread) {
                return flagCheckForLastUserMessage ? isUserChatExpired(currentActiveChatbotThread) : isUserChatExpired(currentActiveChatbotThread) && isLastMarketingTemplateOlderThan24Hours(currentActiveChatbotThread);
            }
        }
        return false;
    },

    handleAnimationOnClickOfManualOverrideBtn: (getManualOverrideConfig: (currentActiveChatbotThread: currentActiveChatbotThreadTypeNew | null) => string) => {
        const {
            currentActiveChatbotThread,
            setFlagAttachmentIconAnimation,
            attachmentAnimationTimeout,
            setAttachmentAnimationTimeout,
            checkIfChatIsExpiredForLeaveBtn,
        } = get();

        if (getManualOverrideConfig(currentActiveChatbotThread)?.toLowerCase() == MANUAL_OVERRIDE_BTN_TEXT['LEAVE']?.toLowerCase() && checkIfChatIsExpiredForLeaveBtn(MANUAL_OVERRIDE_BTN_TEXT['LEAVE'], true)) {
            setFlagAttachmentIconAnimation(false);
            if (attachmentAnimationTimeout) {
                clearTimeout(attachmentAnimationTimeout);
                setAttachmentAnimationTimeout(null);
            }
        }
    }, 

    flagNeedToShowDetailedLogBtn: false,
    setFlagNeedToShowDetailedLogBtn: (value: boolean) => set({ flagNeedToShowDetailedLogBtn: value }),

    flagViewDetailedLog: false,
    setFlagViewDetailedLog: (value: boolean) => set({ flagViewDetailedLog: value }),

    needToShowViewDetailedLogBtn: (userDetail: UserMeResponseDataModel) => {
        const { flagNeedToShowDetailedLogBtn, setFlagNeedToShowDetailedLogBtn } = get();

        if(hasViewDetailedLogBtnAccess(userDetail)){
            if(!flagNeedToShowDetailedLogBtn){
                setFlagNeedToShowDetailedLogBtn(true);
            }

            return true;
        }

        if(flagNeedToShowDetailedLogBtn){
            setFlagNeedToShowDetailedLogBtn(false);
        }
        return false;
    }, 

    cannedResponseList: null,
    setCannedResponseList: (value: CannedResponseTemplate[] | null) => set({ cannedResponseList: value }),

    currentCannedRes: null,
    setCurrentCannedRes: (value: CannedResponseTemplate | null) => set({ currentCannedRes: value }),

    flagPreviewAndSendCannedResPopup: false,
    setFlagPreviewAndSendCannedResPopup: (value: boolean) => set({ flagPreviewAndSendCannedResPopup: value }),

    onChangeOfCannedResMsg: (value: string, index: number) => {
        const currentCannedRes = get().currentCannedRes;
        let updatedCannedRes: CannedResponseTemplate | null = currentCannedRes;
        if(!currentCannedRes) updatedCannedRes = null;
        else {
            updatedCannedRes = {
                ...currentCannedRes,
                canned_response_messages: currentCannedRes?.canned_response_messages?.map((msg, ind) => {
                    if (ind == index) {
                        return {
                            ...msg,
                            message_content: value,
                        }
                    }
                    return msg;
                })
            }
        }
        set({ currentCannedRes: updatedCannedRes });
    },

    getCannedResponseDataApi: async (canned_response_template_id: string | null) => {
        const res = await agent.getCannedResponseTemplateData.get(canned_response_template_id);
        return res;
    },

    checkAgentActivityMsgEnabled: (integrationListNewStructure: (metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew)[] | null) => {
        const currentActiveChatbotThread = get().currentActiveChatbotThread as currentActiveChatbotThreadTypeNew;
        
        if(!currentActiveChatbotThread || !integrationListNewStructure) return false;

        const waba = (integrationListNewStructure?.filter((integration) => integration?.channel_name?.toLowerCase() === currentActiveChatbotThread?.channel_name?.toLowerCase()) as metaIntegrationWhatsAppDataNew[])?.find((integration) => String(integration?.meta_integration_whatsapp_id) === String(currentActiveChatbotThread?.meta_integration_whatsapp_id));
        if(!waba) return false;

        const phoneNumberData = waba?.meta_integration_phone_number_data?.find((phoneNumber) => phoneNumber?.integrated_channel_id === currentActiveChatbotThread?.integrated_channel_id);
        if(!phoneNumberData) return false;

        return phoneNumberData?.flag_send_agent_activity_message ?? false;
    },

    flagSendAgentActivityMsgConfirmation: false,
    setFlagSendAgentActivityMsgConfirmation: (value: boolean) => set({ flagSendAgentActivityMsgConfirmation: value }),

    selectedMessageChatbotData: null,
    setSelectedMessageChatbotData: (value: selectedMessageChatbotData | null) => set({ selectedMessageChatbotData: value }),

    // Thread Info State
    flagOpenThreadInfoBlock: !(window.innerWidth <= 1600 && window.innerWidth >= 1000),
    setFlagOpenThreadInfoBlock: (value: boolean) => set({ flagOpenThreadInfoBlock: value }),

    flagAssignThreadTagPopup: false,
    setFlagAssignThreadTagPopup: (value: boolean) => set({ flagAssignThreadTagPopup: value }),

    threadTagsData: null,
    setThreadTagsData: (value: threadTagsData[] | null) => set({ threadTagsData: value }),
    getThreadTagApi: async () => {
        const res = await agent.getThreadTags.get();
        if(res.status){
            set({ threadTagsData: res?.data });
        } else {
            set({ threadTagsData: null });
        }
        return res;
    },

    selectedThreadTag: null,
    setSelectedThreadTag: (value: threadTagsData | null) => set({ selectedThreadTag: value }),

    flagUpdateThreadTagPopup: false,
    setFlagUpdateThreadTagPopup: (value: boolean) => set({ flagUpdateThreadTagPopup: value }),

    flagDeleteThreadTagConfirmation: false,
    setFlagDeleteThreadTagConfirmation: (value: boolean) => set({ flagDeleteThreadTagConfirmation: value }),

    threadInfoTabValue: 0,
    setThreadInfoTabValue: (val: number) => set({ threadInfoTabValue: val }),

    isInfoTabLoading: false,
    setIsInfoTabLoading: (value: boolean) => set({ isInfoTabLoading: value }),

    sourceDetails: {},
    setSourceDetails: (value: sourceDetails | {}) => set({ sourceDetails: value }),

    feedbackDetails: [],
    setFeedbackDetails: (value: chatbotMessageFeedback[]) => set({ feedbackDetails: value }), 

    feedbackProvidedTypeData: [],
    setFeedbackProvidedTypeData: (value: feedbackProvidedType[]) => set({ feedbackProvidedTypeData: value }),

    feedbackLevelData: [],
    setFeedbackLevelData: (value: feedbackLevel[]) => set({ feedbackLevelData: value }),

    isFeedbackFormOpen: false,
    setIsFeedbackFormOpen: (value: boolean) => set({ isFeedbackFormOpen: value }),

    chatInfoClicked: false,
    setChatInfoClicked: (value: boolean) => set({ chatInfoClicked: value }),
    toggleThreadInfoPanel: () => {
        const { flagOpenThreadInfoBlock, chatClicked, chatInfoClicked } = get();
        set({
            flagOpenThreadInfoBlock: !flagOpenThreadInfoBlock,
            chatClicked: !chatClicked,
            chatInfoClicked: !chatInfoClicked,
        });
    },

    // Initial state
    threads: [],
    setThreads: (threads: RuleBasedThread[]) => set({ threads }),

    stats: {
        total_records: 0,
        start_from: DEFAULT_START_FROM,
        limit: DEFAULT_PAGE_LIMIT,
    },
    setStats: (stats: ThreadListStats) => set({ stats }),

    isLoading: false,
    setIsLoading: (isLoading: boolean) => set({ isLoading }),

    selectedThreadId: null,
    setSelectedThreadId: (threadId: string | null) => set({ selectedThreadId: threadId }),

    selectedThread: null,
    setSelectedThread: (thread: RuleBasedThread | null) => set({ selectedThread: thread }),

    // Current user assignment ID
    userAssignmentId: null,
    setUserAssignmentId: (id: number | null) => set({ userAssignmentId: id }),

    filters: DEFAULT_INBOX_CONTROLS_STATE,
    setFilters: (filters: InboxControlsState) => set({ filters }),

    // ============ Thread Unread Tracking (Frontend-only) ============
    // Tracks which threads have new unread messages (set by socket, cleared on open)
    // Key: threadId, Value: true if has unread messages
    unreadThreads: {} as Record<string, boolean>,

    // Mark a thread as having unread messages (called from socket handlers)
    markThreadAsUnread: (threadId: string) => {
        const { selectedThreadId } = get();
        // Don't mark as unread if the thread is currently open
        if (selectedThreadId === threadId) {
            return;
        }
        set((state) => ({
            unreadThreads: {
                ...state.unreadThreads,
                [threadId]: true,
            },
        }));
    },

    // Clear unread status for a thread (called when user opens the thread)
    // Also clears highlight flags (yellow background) on the thread
    clearThreadUnread: (threadId: string) => {
        set((state) => {
            const newUnreadThreads = { ...state.unreadThreads };
            delete newUnreadThreads[threadId];

            // Also clear highlight flags on the thread object
            const updatedThreads = state.threads.map((thread) => {
                if (thread.thread_id === threadId) {
                    return {
                        ...thread,
                        flag_highlight_thread: false,
                        flag_new_messages: false,
                    };
                }
                return thread;
            });

            return {
                unreadThreads: newUnreadThreads,
                threads: updatedThreads,
            };
        });
    },

    // Check if a thread has unread messages
    isThreadUnread: (threadId: string): boolean => {
        const { unreadThreads } = get();
        return unreadThreads[threadId] === true;
    },

    // Build payload from filters and pagination
    buildPayload: (startFrom: number, limit: number): getRuleBasedInboxThreadsPayload => {
        const state = get();
        const { filters, userAssignmentId } = state;

        // Calculate last_activity_after based on lastActivity filter
        let lastActivityAfter: string | undefined;
        if (filters.lastActivity !== "all") {
            const now = new Date();
            if (filters.lastActivity === "24h") {
                lastActivityAfter = new Date(now.getTime() - 24 * 60 * 60 * 1000).toISOString();
            } else if (filters.lastActivity === "3d") {
                lastActivityAfter = new Date(now.getTime() - 3 * 24 * 60 * 60 * 1000).toISOString();
            } else if (filters.lastActivity === "7d") {
                lastActivityAfter = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000).toISOString();
            }
        } else {
            // For "all", use the default date as per API spec
            lastActivityAfter = "2020-01-01T01:01:01.100Z";
        }

        // Build base payload
        const payload: getRuleBasedInboxThreadsPayload = {
            start_from: startFrom,
            limit: limit,
            flag_active: filters.conversationType === "Active",
        };

        // Handle assignment scope (checkboxes - can select both)
        // If "Assigned to Me" is checked, send user_assignment_id in assigned param
        if (filters.flagAssignedToMe && userAssignmentId) {
            payload.assigned = userAssignmentId.toString();
        }
        // If "Unassigned" is checked, send flag_unassigned: true
        if (filters.flagUnassigned) {
            payload.flag_unassigned = true;
        }
        // If both are checked, both params are sent
        // If neither is checked, neither param is sent (shows all threads)

        // Handle ticket status IDs (from ticketStatusIds array)
        if (filters.ticketStatusIds && filters.ticketStatusIds.length > 0) {
            payload.ticket_status_ids = filters.ticketStatusIds.join(",");
        }

        if(filters.flagTicketUnassigned){
            payload.flag_ticket_unassigned = true;
        }

        if(filters.flagTicketAssignedToOther){
            payload.flag_ticket_assigned_to_other = true;
        }

        if(filters.ticketAssignedTo && filters.ticketAssignedTo.length > 0){
            payload.ticket_assigned_to = filters.ticketAssignedTo.join(",");
        }

        // Handle tags (comma separated IDs)
        if (filters.tags && filters.tags.length > 0) {
            payload.ticket_tag_ids = filters.tags.join(",");
        }

        if(filters.ticketCreatedBy && filters.ticketCreatedBy.length > 0){
            payload.ticket_created_by = filters.ticketCreatedBy.join(",");
        }

        // Handle channels
        if (filters.channels && filters.channels.length > 0) {
            payload.channel_id = filters.channels.join(",");
        }

        // Handle last activity
        if (lastActivityAfter) {
            payload.last_activity_after = lastActivityAfter;
        }

        // Handle archived/unarchived filter (only when "All" is selected)
        // If both are selected or neither is selected, don't send flag_archive
        // If only Archived is selected, flag_archive = true
        // If only Unarchived is selected, flag_archive = false
        if (filters.conversationType === "All") {
            if (filters.flagArchived && !filters.flagUnarchived) {
                payload.flag_archive = true;
            } else if (!filters.flagArchived && filters.flagUnarchived) {
                payload.flag_archive = false;
            }
            // If both or neither selected, don't send flag_archive
        }

        // Handle search phrase - only include if not empty
        if (filters.searchQuery && filters.searchQuery.trim().length > 0) {
            payload.user_info_phrase = filters.searchQuery.trim();
        } 

        if(filters.ticketSearchQuery && filters.ticketSearchQuery.trim().length > 0) {
            payload.ticket_info_phrase = filters.ticketSearchQuery.trim();
        }

        if(filters.integratedChannelId && filters.integratedChannelId?.length > 0) {
            payload.integrated_channel_id = filters.integratedChannelId.join(",");
        }

        return payload;
    },

    // Fetch threads function
    fetchThreads: async (startFrom: number = DEFAULT_START_FROM, limit: number = DEFAULT_PAGE_LIMIT) => {
        set({ isLoading: true });

        try {
            const state = get();
            const payload = state.buildPayload(startFrom, limit);
            const response = await agent.getRuleBasedInboxThreads.get(payload);

            if (response?.status && response?.data) {
                set({
                    threads: sortThreads(response.data),
                    stats: {
                        total_records: typeof response.stats?.total_records === "string"
                            ? parseInt(response.stats.total_records, 10)
                            : response.stats?.total_records || 0,
                        start_from: typeof response.stats?.start_from === "string"
                            ? parseInt(response.stats.start_from, 10)
                            : response.stats?.start_from || startFrom,
                        limit: typeof response.stats?.limit === "string"
                            ? parseInt(response.stats.limit, 10)
                            : response.stats?.limit || limit,
                    },
                });
            } else {
                // Fallback to empty data
                set({
                    threads: [],
                    stats: {
                        total_records: 0,
                        start_from: startFrom,
                        limit: limit,
                    },
                });
            }
        } catch (error) {
            console.error("Error fetching threads:", error);
            // Fallback to empty data on error
            set({
                threads: [],
                stats: {
                    total_records: 0,
                    start_from: startFrom,
                    limit: limit,
                },
            });
        } finally {
            set({ isLoading: false });
        }
    },

    // Thread detail state
    threadDetail: null,
    setThreadDetail: (detail: any | null) => set({ threadDetail: detail }),

    isLoadingThreadDetail: false,
    setIsLoadingThreadDetail: (loading: boolean) => set({ isLoadingThreadDetail: loading }),

    // Fetch thread details function
    fetchThreadDetail: async (threadId: string, offset: number = 0, limit: number = 50) => {
        set({ isLoadingThreadDetail: true });

        try {
            // Fetch thread details - rule-based chats use flag_new structure
            const response = await agent.getThreadDetails.get(threadId, "false", limit, offset);

            if (response?.status && response?.data) {
                const threadData = response.data;

                // Default action types that should be shown
                const defaultActionTypes = [
                    "send_wa_dm_text",
                    "send_wa_dm_template",
                    "send_wa_dm_media",
                    "send_wa_dm_carousel_template",
                    "send_order_details_template",
                    "chatbot_closed",
                    "chatbot_deployed",
                    "wa_dm_media_received",
                    "wa_dm_text_received",
                    "manual_agent_assigned",
                    "manual_agent_joined",
                    "manual_agent_left",
                ];

                // Transform thread_execution_data to chatbot_thread_data format
                const chatbotThreadData = (threadData.thread_execution_data || [])
                    .filter((execution: any) => {
                        // Only show actions that should be visible
                        const actionType = execution.action_type_name?.toLowerCase() || "";
                        return defaultActionTypes.includes(actionType);
                    })
                    .map((execution: any) => {
                        const actionType = execution.action_type_name?.toLowerCase() || "";
                        // const isUserMessage = userMessageActionTypes.includes(actionType);

                        return {
                            thread_execution_log_id: execution.thread_execution_log_id,
                            chatbot_thread_id: execution.thread_execution_log_id,
                            action_type_name: execution.action_type_name,
                            chatbot_thread_action_type: execution.action_type_name,
                            chatbot_thread_value: execution.action_execution_data?.message ||
                                execution.action_execution_data?.wa_body_text || "",
                            timestamp: execution.step_end_timestamp || execution.step_start_timestamp,
                            step_start_timestamp: execution.step_start_timestamp,
                            step_end_timestamp: execution.step_end_timestamp,
                            flag_user_message: isUserMessage(actionType, execution?.action_execution_data),
                            flag_show_action: true,
                            action_execution_data: execution.action_execution_data || {},
                            chatbot_action_execution_data: execution.action_execution_data || {},
                            chatbot_data: execution.chatbot_data,
                            user_first_name: execution.user_first_name,
                            user_last_name: execution.user_last_name,
                            user_email: execution.user_email,
                            parent_thread_execution_log_id: execution.parent_thread_execution_log_id,
                            chatbot_user_active_flag: true,
                        };
                    });

                set({
                    threadDetail: {
                        ...threadData,
                        chatbot_user_id: threadData.thread_id,
                        chatbot_thread_data: chatbotThreadData,
                        chatbot_name: threadData.thread_metadata?.find((m: any) => m.metadata_type_name === "name")?.metadata_value || "Unknown",
                        chatbot_user_route_source: threadData.channel_name,
                    },
                });
            } else {
                set({ threadDetail: null });
            }
        } catch (error) {
            console.error("Error fetching thread detail:", error);
            set({ threadDetail: null });
        } finally {
            set({ isLoadingThreadDetail: false });
        }
    },

    // ============ Socket Handling Functions ============

    // Update thread in list (for new messages - highlight and update last_message_time)
    updateThreadInList: (threadId: string, lastMessageTime: string, lastActivityInboxCriteriaTimeStamp: string, flagHighlight = false, flagNewMessages = false, lastMessage?: any, manual_agent_data?: ThreadManualAgentData[], placeAtBottomOfRecent = false) => {
        const { threads, markThreadAsUnread, recentThreadIds } = get();
        // Mark thread as unread when new messages arrive (only if not currently open)
        if (flagNewMessages || flagHighlight) {
            markThreadAsUnread(threadId);
        }
        const actionTypeNamesToBeExcludedInThreadLastMessage = ['manual_agent_assigned', 'manual_agent_joined', 'manual_agent_left']
        const ignoreLastMessage = lastMessage?.action_type_name && actionTypeNamesToBeExcludedInThreadLastMessage.includes(lastMessage.action_type_name)
        // Update the thread data - preserve existing data when not provided

        const updatedThreads = threads.map((thread) => {
            if (String(thread.thread_id) === String(threadId)) {
                return {
                    ...thread,
                    thread_last_updated_timestamp: lastMessageTime,
                    thread_last_activity_inbox_criteria: lastActivityInboxCriteriaTimeStamp,
                    flag_highlight_thread: flagHighlight,
                    flag_new_messages: flagNewMessages,
                    ...(lastMessage && !ignoreLastMessage ? { last_message: lastMessage } : {}),
                    // Only update manual_agent_data if provided, otherwise keep existing
                    ...(manual_agent_data !== undefined ? { manual_agent_data: manual_agent_data } : []),
                };
            }
            return thread;
        });

        // Socket path: place at bottom of Recent group. Do NOT fall back to timestamp sort —
        // that would jump the thread above every Recent thread (the bug we are fixing).
        // Page refresh / API load still uses sortThreads separately.
        if (placeAtBottomOfRecent) {
            // Ensure current thread is treated as recent while placing
            const recentIdsForPlacement = {
                ...recentThreadIds,
                [threadId]: true,
                [String(threadId)]: true,
            };
            set({ threads: placeThreadAtBottomOfRecentGroup(updatedThreads, threadId, recentIdsForPlacement) });
            return;
        }

        // Content-only update (e.g. delivery status) — keep current list order
        set({ threads: updatedThreads });
    },

    // Add new thread to list (for new user conversations)
    // Only adds if on page 1 (start_from === 1)
    addNewThreadToList: (thread: RuleBasedThread) => {
        // const { threads, stats, markThreadAsUnread, markThreadAsRecent, filters } = get();
        const { threads, stats, markThreadAsUnread, markThreadAsRecent, filters, recentThreadIds } = get();

        // Only add new thread if we're on page 1 (handle both string and number)
        const currentStartFrom = typeof stats.start_from === "string"
            ? parseInt(stats.start_from, 10)
            : stats.start_from;

        if (currentStartFrom !== 1) {
            return; // Not on page 1, don't add to list
        }

        // Check if thread already exists
        const existingThread = threads.find((t) => String(t.thread_id) === String(thread.thread_id));
        if (existingThread) {
            return; // Thread already exists, don't add duplicate
        }

        // Check if thread matches search filter (if search is active)
        if (!doesThreadMatchSearchFilter(thread, filters.searchQuery)) {
            return; // Thread doesn't match search query, don't add to list
        }

        // Mark new thread as unread (new conversation = unread)
        markThreadAsUnread(thread.thread_id);

        // Mark new thread as recent and place at bottom of Recent group (same as socket updates)
        markThreadAsRecent(thread.thread_id);

        const updatedThreads = [...threads, thread];
        const recentIdsForPlacement = {
            ...recentThreadIds,
            [thread.thread_id]: true,
            [String(thread.thread_id)]: true,
        };
        const currentTotalRecords = typeof stats.total_records === "string"
            ? parseInt(stats.total_records, 10)
            : stats.total_records;

        set({ 
            threads: placeThreadAtBottomOfRecentGroup(updatedThreads, thread.thread_id, recentIdsForPlacement),
            stats: {
                ...stats,
                total_records: (currentTotalRecords || 0) + 1, // Increase the total records by one (New Thread)
            },
        });
    },

    // Update thread metadata (for static_workflow_inbox_activity and manual agent actions)
    updateThreadMetadata: (threadId: string, updates: {
        thread_status?: any;
        thread_tags?: any[];
        thread_notes?: any[];
        thread_ticket_data?: threadTickets[];
        flag_archive?: boolean;
        manual_agent_data?: any[];
    }) => {
        const { threads, selectedThreadId, filters, userAssignmentId } = get();
        // Check if thread exists in list
        const existingThread = threads.find((t) => t.thread_id === threadId);
        if (!existingThread) {
            return;
        }

        // Build the updated thread for filter checking
        const threadForCheck = {
            flag_archive: updates.flag_archive ?? existingThread.flag_archive,
            manual_agent_data: updates.manual_agent_data ?? existingThread.manual_agent_data ?? [],
            thread_last_activity_inbox_criteria: existingThread.thread_last_activity_inbox_criteria,
            thread_status: updates.thread_status !== undefined ? updates.thread_status : existingThread.thread_status,
            thread_tags: updates.thread_tags ?? existingThread.thread_tags ?? [],
            thread_ticket_data: updates.thread_ticket_data ?? existingThread?.thread_ticket_data ?? [],
            channel_id: existingThread.channel_id,
        };

        // Check if thread should be removed from list
        // threadExistsInList: true means only filter check is done (startFrom/actionTypeName ignored)
        const decision = getThreadVisibilityDecision(threadForCheck, {
            filters,
            userAssignmentId,
            threadExistsInList: true,
            startFrom: 1, // Not used when threadExistsInList is true
            actionTypeName: "", // Not used when threadExistsInList is true
        });


        // If thread no longer matches filters, remove from list
        if (decision.action === "remove") {
            set({ threads: threads.filter((t) => t.thread_id !== threadId) });
            return;
        }

        // Update thread in list (including flag_archive status and manual_agent_data)
        const updatedThreads = threads.map((thread) => {
            if (thread.thread_id === threadId) {
                return {
                    ...thread,
                    ...(updates.thread_status !== undefined && { thread_status: updates.thread_status }),
                    ...(updates.thread_tags !== undefined && { thread_tags: updates.thread_tags }),
                    ...(updates.thread_notes !== undefined && { thread_notes: updates.thread_notes }),
                    ...(updates.thread_ticket_data !== undefined && { thread_ticket_data: updates.thread_ticket_data } ),
                    ...(updates.flag_archive !== undefined && { flag_archive: updates.flag_archive }),
                    ...(updates.manual_agent_data !== undefined && { manual_agent_data: updates.manual_agent_data }),
                };
            }
            return thread;
        });

        set({ threads: updatedThreads });

        // If this is the currently selected thread, also update selectedThread
        if (selectedThreadId === threadId) {
            const selectedThread = get().selectedThread;
            if (selectedThread) {
                set({
                    selectedThread: {
                        ...selectedThread,
                        ...(updates.thread_status !== undefined && { thread_status: updates.thread_status }),
                        ...(updates.thread_tags !== undefined && { thread_tags: updates.thread_tags }),
                        ...(updates.thread_notes !== undefined && { thread_notes: updates.thread_notes }),
                        ...(updates.thread_ticket_data !== undefined && { thread_ticket_data: updates.thread_ticket_data } ),
                        ...(updates.manual_agent_data !== undefined && { manual_agent_data: updates.manual_agent_data }),
                    },
                });
            }
        }
    },

    // Remove highlight from thread after timeout
    // Clears both flag_highlight_thread and flag_new_messages
    removeThreadHighlight: (threadId: string) => {
        const { threads } = get();

        const updatedThreads = threads.map((thread) => {
            if (thread.thread_id === threadId) {
                return {
                    ...thread,
                    flag_highlight_thread: false,
                    flag_new_messages: false,
                };
            }
            return thread;
        });

        set({ threads: updatedThreads });
    },

    // ============ Recent Chats Tracking ============
    // Record of thread IDs that are marked as "Recent"
    // Key: threadId, Value: true if marked as recent
    recentThreadIds: {} as Record<string, boolean>,

    // Mark a thread as recent
    markThreadAsRecent: (threadId: string) => {
        set((state) => ({
            recentThreadIds: {
                ...state.recentThreadIds,
                [threadId]: true,
            },
        }));
    },

    // Remove thread from recent list
    unmarkThreadAsRecent: (threadId: string) => {
        set((state) => {
            const newRecentThreadIds = { ...state.recentThreadIds };
            delete newRecentThreadIds[threadId];
            return { recentThreadIds: newRecentThreadIds };
        });
    },

    // Check if a thread is marked as recent
    isThreadRecent: (threadId: string): boolean => {
        const recentThreadIds = get().recentThreadIds;
        return recentThreadIds[threadId] === true || recentThreadIds[String(threadId)] === true;
    },

    // Check all threads and update their recent status
    // Removes threads from recent if they're older than threshold
    // Also re-sorts non-recent threads
    refreshRecentThreads: (): string[] => {
        const { threads, recentThreadIds } = get();
        const removedFromRecent: string[] = [];
        const newRecentThreadIds: Record<string, boolean> = {};

        // Check each recent thread if it's still within threshold
        Object.keys(recentThreadIds).forEach((threadId) => {
            if (recentThreadIds[threadId]) {
                const thread = threads.find((t) => t.thread_id === threadId);
                if (thread && isWithinRecentThreshold(thread.thread_last_activity_inbox_criteria)) {
                    newRecentThreadIds[threadId] = true;
                } else {
                    removedFromRecent.push(threadId);
                }
            }
        });

        // If any threads were removed from recent, we need to re-sort the list
        if (removedFromRecent.length > 0) {
            set({
                threads: sortThreads(threads),
                recentThreadIds: newRecentThreadIds,
            });
        } else {
            set({ recentThreadIds: newRecentThreadIds });
        }

        return removedFromRecent;
    },

    // Clear all recent thread IDs
    clearAllRecentThreads: () => {
        set({ recentThreadIds: {} });
    },

    // Initialize recent threads based on current thread list
    // Called when threads are loaded on page 1
    initializeRecentThreads: () => {
        const { threads, stats } = get();

        // Only initialize if on page 1
        const currentStartFrom = typeof stats.start_from === "string"
            ? parseInt(stats.start_from, 10)
            : stats.start_from;

        if (currentStartFrom !== 1) {
            set({ recentThreadIds: {} });
            return;
        }

        // Find threads within the recent threshold
        const newRecentThreadIds: Record<string, boolean> = {};
        threads.forEach((thread) => {
            if (isWithinRecentThreshold(thread.thread_last_activity_inbox_criteria)) {
                newRecentThreadIds[thread.thread_id] = true;
            }
        });

        set({ recentThreadIds: newRecentThreadIds }); 

    },

    userInfoSearchPhrase: '', 
    setUserInfoSearchPhrase: (value: string) => set({ userInfoSearchPhrase: value }),

    ticketInfoSearchPhrase: '',
    setTicketInfoSearchPhrase: (value: string) => set({ ticketInfoSearchPhrase: value }),
    // ============ Thread Conversation Cache ============

    threadCache: {} as Record<string, ThreadCacheEntry>,

    setThreadCache: (threadId: string, entry: ThreadCacheEntry) => {
        set((state) => ({
            threadCache: {
                ...state.threadCache,
                [threadId]: {
                    ...entry,
                    // Isolate cached data from live currentActiveChatbotThread so
                    // in-place mutations cannot corrupt other threads' cache entries.
                    data: structuredClone(entry.data),
                },
            },
        }));
    },

    getThreadFromCache: (threadId: string): ThreadCacheEntry | null => {
        return get().threadCache[threadId] ?? null;
    },

    clearThreadFromCache: (threadId: string) => {
        set((state) => {
            const updated = { ...state.threadCache };
            delete updated[threadId];
            const updatedDrafts = { ...state.threadDraftById };
            delete updatedDrafts[threadId];
            return { threadCache: updated, threadDraftById: updatedDrafts };
        });
    },

    clearAllThreadCache: () => {
        set({ threadCache: {}, threadDraftById: {} });
    },

    // ============ Thread Scroll Position Memory ============

    threadScrollPositions: {} as Record<string, number>,

    saveThreadScrollPosition: (threadId: string, scrollTop: number) => {
        set((state) => ({
            threadScrollPositions: {
                ...state.threadScrollPositions,
                [threadId]: scrollTop,
            },
        }));
    },

    getThreadScrollPosition: (threadId: string): number | null => {
        const pos = get().threadScrollPositions[threadId];
        return pos !== undefined ? pos : null;
    },

    clearThreadScrollPosition: (threadId: string) => {
        set((state) => {
            const updated = { ...state.threadScrollPositions };
            delete updated[threadId];
            return { threadScrollPositions: updated };
        });
    },

    // ============ Per-thread composer drafts ============

    threadDraftById: {} as Record<string, string>,

    setThreadDraft: (threadId: string, draft: string) => {
        const { threadDraftById } = get();
        if (!draft) {
            if (!(threadId in threadDraftById)) return;
            const updated = { ...threadDraftById };
            delete updated[threadId];
            set({ threadDraftById: updated });
            return;
        }
        if (threadDraftById[threadId] === draft) return;
        set({
            threadDraftById: {
                ...threadDraftById,
                [threadId]: draft,
            },
        });
    },

    clearThreadDraft: (threadId: string) => {
        const { threadDraftById } = get();
        if (!(threadId in threadDraftById)) return;
        const updated = { ...threadDraftById };
        delete updated[threadId];
        set({ threadDraftById: updated });
    },

    clearAllThreadDrafts: () => {
        set({ threadDraftById: {} });
    },

    selectedAgentId: null,
    setSelectedAgentId: (value: string | null) => set({ selectedAgentId: value }), 

    newThreadInfo: null,
    setNewThreadInfo: (value: newThreadInfo | null) => set({ newThreadInfo: value }), 

    flagRenderNewConversation: false,
    setFlagRenderNewConversation: (value: boolean) => set({ flagRenderNewConversation: value }),

    getAllIntegratedChannelsApi: async () => {
        const res = await agent.getAllIntegratedChannels.get();
        return res; 
    },

    integratedChannels: null,
    setIntegratedChannels: (value: integratedChannel[] | null) => set({ integratedChannels: value }),

    hasThreadLastActivityInboxCriteriaChanged: (threadId: string, newLastActivityInboxCriteria: string) => {
        if(!newLastActivityInboxCriteria) return false;

        const { threads } = get();

        return threads.some((thread) => (String(thread.thread_id) === String(threadId) && thread.thread_last_activity_inbox_criteria !== newLastActivityInboxCriteria));
    },

    userTimeZoneHour: null,
    setUserTimeZoneHour: (value: string | null) => set({ userTimeZoneHour: value }),

    getWabaNameAndPhoneNumberBytIntegratedChannelId: (
        integrated_channel_name: string,
        integrated_channel_id: number,
        meta_integration_whatsapp_id?: string | number,
    ) => {
        const listOfIntegration = get().listOfIntegration;
        if (listOfIntegration) {
            let whatsappData = listOfIntegration.filter((integration: metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew) => integration.channel_name.toLowerCase() == integrated_channel_name?.toLowerCase()) as metaIntegrationWhatsAppDataNew[];

            if (meta_integration_whatsapp_id != null && meta_integration_whatsapp_id !== '') {
                whatsappData = whatsappData.filter(
                    (integration) => String(integration.meta_integration_whatsapp_id) === String(meta_integration_whatsapp_id),
                );
            }

            let integratedPhoneNumberData: metaIntegrationPhoneNumberDataNew | undefined = whatsappData.flatMap((phoneNumberData: metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew) => {
                if ("meta_integration_phone_number_data" in phoneNumberData) {
                    return phoneNumberData.meta_integration_phone_number_data;
                }
                return [];
            }).find((integration: metaIntegrationPhoneNumberDataNew) => integration.integrated_channel_id == integrated_channel_id);

            return {
                waba_name: integratedPhoneNumberData?.verified_name || "",
                phone_number: integratedPhoneNumberData?.display_phone_number || "",
                phone_number_id: integratedPhoneNumberData?.phone_number_id || ""
            }
        } else {
            return null;
        }
    },

    getIntegratedChannelData: (integrated_channel_name: string, integrated_channel_id: number, listOfIntegration: (metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew)[] | null, chatbotName: string) => {
        let channel_name = integrated_channel_name?.toLowerCase()
        if (listOfIntegration) {
            switch (channel_name) {
                case THREAD_CHANNEL_NAMES['WHATSAPP']?.toLowerCase():
                    const waba_obj = get().getWabaNameAndPhoneNumberBytIntegratedChannelId(integrated_channel_name, integrated_channel_id);
                    return `${waba_obj?.waba_name || ""} | ${waba_obj?.phone_number || ""}`;
                case THREAD_CHANNEL_NAMES['INSTAGRAM']?.toLowerCase():
                    let instagramData = listOfIntegration.filter((integration: metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew) => integration.channel_name.toLowerCase() == integrated_channel_name.toLowerCase())
                    return (instagramData && "instagram_account_name" in instagramData[0]) ? instagramData[0].instagram_account_name : "";
                case THREAD_CHANNEL_NAMES['CHRNOX_AI_WEB_APP']?.toLowerCase():
                case THREAD_CHANNEL_NAMES['CHRONOX_AI_WEB_APP']?.toLowerCase():
                case THREAD_CHANNEL_NAMES['WEBSITE']?.toLowerCase():
                    return getValueOrDefault(chatbotName);
                default:
                    return "-"
            }
        }
    },

    setManualAgentDataInThreadList: (action: string, chatbot_user_id: string, agent_data: manualAgentData) => {
        const { filteredData, setFilteredData } = get();

        let updatedActiveChat = filteredData?.activeChats;
        let updatedActiveFilteredChat = filteredData?.activeChatsFiltered;

        switch(action?.toLowerCase()){
            case AGENT_ACTIVITY_ACTION_TYPE['ASSIGN']:
                updatedActiveChat = updatedActiveChat?.map((chat) => { 
                    if(chatbot_user_id == chat?.chatbot_user_id && "flag_new" in chat){
                        return {
                            ...chat, 
                            manual_agent_data: agent_data ? [...chat?.manual_agent_data, agent_data] : chat?.manual_agent_data,
                        }
                    }
                    return chat;
                }); 
                updatedActiveFilteredChat = updatedActiveFilteredChat?.map((chat) => { 
                    if(chatbot_user_id == chat?.chatbot_user_id && "flag_new" in chat){
                        return {
                            ...chat, 
                            manual_agent_data: agent_data ? [...chat?.manual_agent_data, agent_data] : chat?.manual_agent_data,
                        }
                    }
                    return chat;
                }); 
                break;
            case AGENT_ACTIVITY_ACTION_TYPE['JOIN']: 
                updatedActiveChat = updatedActiveChat?.map((chat) => { 
                    if(chatbot_user_id == chat?.chatbot_user_id && "flag_new" in chat){
                        return {
                            ...chat,   
                            manual_agent_data: chat.manual_agent_data?.map((agent) => {
                                if(agent.thread_manual_agent_id == agent_data?.thread_manual_agent_id){
                                    return {
                                        ...agent, 
                                        timestamp_joined: agent_data?.timestamp_joined,
                                    }
                                }
                                return agent;
                            }),
                        }
                    }
                    return chat;
                }); 
                updatedActiveFilteredChat = updatedActiveFilteredChat?.map((chat) => { 
                    if(chatbot_user_id == chat?.chatbot_user_id && "flag_new" in chat){
                        return {
                            ...chat, 
                                manual_agent_data: chat.manual_agent_data?.map((agent) => {
                                if(agent.thread_manual_agent_id == agent_data?.thread_manual_agent_id){
                                    return {
                                        ...agent, 
                                        timestamp_joined: agent_data?.timestamp_joined,
                                    }
                                }
                                return agent;
                            }),
                        }
                    }
                    return chat;
                }); 
                break;
            case AGENT_ACTIVITY_ACTION_TYPE['LEFT']: 
                updatedActiveChat = updatedActiveChat?.map((chat) => { 
                    if(chatbot_user_id == chat?.chatbot_user_id && "flag_new" in chat){
                        return {
                            ...chat, 
                            manual_agent_data: chat.manual_agent_data?.filter((agent) => agent?.thread_manual_agent_id != agent_data?.thread_manual_agent_id),
                        }
                    }
                    return chat;
                }); 
                updatedActiveFilteredChat = updatedActiveFilteredChat?.map((chat) => { 
                    if(chatbot_user_id == chat?.chatbot_user_id && "flag_new" in chat){
                        return {
                            ...chat, 
                            manual_agent_data: chat.manual_agent_data?.filter((agent) => agent?.thread_manual_agent_id != agent_data?.thread_manual_agent_id),
                        }
                    }
                    return chat;
                }); 
                break;
        }
        const updatedFilteredDataValue = {
            ...filteredData, 
            activeChats: updatedActiveChat, 
            activeChatsFiltered: updatedActiveFilteredChat,
        };
        setFilteredData(updatedFilteredDataValue);
    },

    setManualAgentDataInCurrentThread: (action: string, agent_data: manualAgentData, threadId: string) => {
        const currentActiveChatbotThread = get().currentActiveChatbotThread as currentActiveChatbotThreadTypeNew;
        const setCurrentActiveChatbotThread = get().setCurrentActiveChatbotThread;
        let updatedCurrentActiveThread = currentActiveChatbotThread;
        
        if(threadId !== currentActiveChatbotThread?.chatbot_user_id) return;

        switch(action?.toLowerCase()){
            case AGENT_ACTIVITY_ACTION_TYPE['ASSIGN']:
                updatedCurrentActiveThread = {
                    ...updatedCurrentActiveThread,
                    manual_agent_data: currentActiveChatbotThread?.manual_agent_data?.find((agent) => agent?.user_assignment_id == agent_data?.user_assignment_id)  ?
                            currentActiveChatbotThread?.manual_agent_data
                            :
                            [...(currentActiveChatbotThread.manual_agent_data || []), ...(agent_data ? [agent_data] : [])],
                }
                break;
            case AGENT_ACTIVITY_ACTION_TYPE['JOIN']: 
                updatedCurrentActiveThread = {
                    ...updatedCurrentActiveThread, 
                    manual_agent_data: updatedCurrentActiveThread.manual_agent_data?.map((agent) => {
                        if(agent.thread_manual_agent_id = (agent_data?.thread_manual_agent_id ?? "")){
                            return {
                                ...agent, 
                                timestamp_joined: agent_data?.timestamp_joined,
                            }
                        }
                        return agent;
                    }), 
                }
                break;
            case AGENT_ACTIVITY_ACTION_TYPE['LEFT']:
                updatedCurrentActiveThread = {
                    ...updatedCurrentActiveThread, 
                    manual_agent_data: updatedCurrentActiveThread?.manual_agent_data?.filter((agent) => agent?.thread_manual_agent_id != agent_data?.thread_manual_agent_id),
                }
                break;
        }
        setCurrentActiveChatbotThread(updatedCurrentActiveThread);
    },

    getInstaAccountNameAndIdByIntegratedChannelId: (
        integrated_channel_name: string,
        integrated_channel_id: number,
    ) => {
        const listOfIntegration = get().listOfIntegration;
        if (!listOfIntegration) return null;
    
        const instagramData = listOfIntegration.find(
            (integration: metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew) =>
                integration.channel_name?.toLowerCase() === integrated_channel_name?.toLowerCase() &&
                Number((integration as metIntegrationInstagramDataNew).integrated_channel_id) === Number(integrated_channel_id)
        ) as metIntegrationInstagramDataNew | undefined;
    
        return {
            instagram_account_name: instagramData?.instagram_account_name || "",
            instagram_account_id: instagramData?.instagram_account_id || "",
        };
    },
    
}));

